import { SnippetLanguage } from './types';

const snippetLanguageOrder: SnippetLanguage[] = [
  'URL',
  'cURL',
  'REST',
  'Node.js',
  'React',
  'Vue.js',
  'Angular',
  'JS',
  'Python',
  'PHP',
  'Java',
  'Go',
  'Ruby',
  '.NET',
  'Dart',
  'iOS',
  'Android',
  'Flutter',
  'Kotlin',
  'jQuery',
  'CLI',
];

export const getSortOrder = (language: SnippetLanguage): number =>
  snippetLanguageOrder.includes(language) ? snippetLanguageOrder.indexOf(language) : 999;
